import { render } from "./Tiptap-editor.vue?vue&type=template&id=ec1624e8&scoped=true"
import script from "./Tiptap-editor.vue?vue&type=script&lang=js"
export * from "./Tiptap-editor.vue?vue&type=script&lang=js"

import "./Tiptap-editor.vue?vue&type=style&index=0&id=ec1624e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1624e8"]])

export default __exports__